import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Container, Row, Col } from "react-bootstrap";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import BCASchedulerListings from "../../components/broadcast-system/bca-scheduler/BCASchedulerListings";
import { fetchBCASchedulerData } from "../../redux/ad-blog-reducers/blogSlice";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import BCASchedulerTemplates from "../../components/broadcast-system/bca-scheduler/BCASchedulerTemplates";
import "../../styles/broadcast-system/bca-scheduler.css";
import BCASchedulerForm from "../../components/broadcast-system/bca-scheduler/BCASchedulerForm";
import BCAScheduledBroadcastLogsStructure from "../../components/broadcast-system/bca-scheduler/BCAScheduledBroadcastLogsStructure";

const BCAScheduler = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const { bcaSchedulerLoading } = useSelector((state) => state.blog);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniAllFilter = {
    selectedWPTemplate: "",
    selectedBCASchedulerCondition: "",
    isActive: "",
    selectedScheduleType: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    include_templates: "true",
    condition: allFilters.selectedBCASchedulerCondition?.value || "",
    whatsapp_template_name: allFilters.selectedWPTemplate?.value || "",
    status: allFilters.isActive?.value || "",
    condition_type: allFilters.selectedScheduleType?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setSearchFilterApplied(false);
    setIsPage(0);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const getBcaSchedulerListings = (filters) => {
    dispatch(
      fetchBCASchedulerData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getBcaSchedulerListings(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      condition: allFilters.selectedBCASchedulerCondition?.value || "",
      whatsapp_template_name: allFilters.selectedWPTemplate?.value || "",
      status: allFilters.isActive?.value || "",
      condition_type: allFilters.selectedScheduleType?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedBCASchedulerCondition,
    allFilters.selectedWPTemplate,
    allFilters.isActive,
    allFilters.selectedScheduleType,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Broadcast Scheduler">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}>
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "add" || modValues.modName === "edit"
                ? "mod-width-70p mod-height-95vh"
                : modValues.modName === "scheduled-broadcast-logs"
                ? ""
                : "mod-width-50p"
            }`}>
            <ModalHeadAndClose
              title={
                modValues.modName === "wp_template" ||
                modValues.modName === "push_template"
                  ? modValues.rowData?.name || "NA"
                  : modValues.modName === "add"
                  ? "Add Broadcast Scheduler"
                  : modValues.modName === "edit"
                  ? "Update Broadcast Scheduler"
                  : modValues.modName === "scheduled-broadcast-logs"
                  ? ""
                  : modValues.modName?.replace(/_/g, " ")
              }
              onClose={onCloseModal}
            />

            {modValues.modName === "description" ? (
              <div className="discussionModalMessage mt30">
                <p
                  className="message"
                  dangerouslySetInnerHTML={{
                    __html:
                      modValues.rowData?.description || "No Content Available",
                  }}></p>
              </div>
            ) : modValues.modName === "wp_template" ||
              modValues.modName === "push_template" ? (
              <BCASchedulerTemplates
                template={
                  modValues.modName === "wp_template" ? "whatsapp" : "push"
                }
                rowData={modValues.rowData}
              />
            ) : modValues.modName === "add" || modValues.modName === "edit" ? (
              <BCASchedulerForm
                isEdit={modValues.modName === "edit"}
                rowData={modValues.rowData}
                userInfoData={userInfoData}
                callFunction={() => getBcaSchedulerListings(filters)}
                closeModal={onCloseModal}
              />
            ) : modValues.modName === "scheduled-broadcast-logs" ? (
              <BCAScheduledBroadcastLogsStructure userInfoData={userInfoData} />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"BCA & Fitness Profile Broadcast Scheduler"}
              isReload={() => getBcaSchedulerListings(filters)}
              createBtnTxt={"+ Add New"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add",
                }))
              }
              createBtnTxt1="View Schedule Logs"
              onClickCreateBtn1={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "scheduled-broadcast-logs",
                }));
              }}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from="bca-scheduler"
              userInfoData={userInfoData}
              searchFilterApplied={searchFilterApplied}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              onClickReset={onResetFilters}
              isLoading={bcaSchedulerLoading}
              searchPlaceHolder="Search by name . . ."
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <BCASchedulerListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              userInfoData={userInfoData}
              callFunction={() => getBcaSchedulerListings(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default BCAScheduler;
